var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-one-quarter has-borders-column"},[_c('span',{staticClass:"heading-inline"},[_vm._v("Metody wpłaty")]),_c('br'),_c('FundingMethodsList',{attrs:{"fundingMethods":_vm.broker.fundingMethods}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }